import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const BoltIcon = (props: IconProps) => (
  <ChakraIcon viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M13 2 3 14h7l-1 8 10-12h-7l1-8z" />
  </ChakraIcon>
)

export default BoltIcon
